require.context('favicon', true)
